import { createSlice  } from "@reduxjs/toolkit";

const initialState = {
    isCollaped: true,
}

export const sidebarSlice = createSlice({
    name: "sidebar",
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.isCollaped = !state.isCollaped;
        }
    }
}
);

export const { toggleSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;